import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import MultiSelect, { IOption } from "../../atoms/forms/MultiSelect";
import { ICommonMultiSelectControls } from "./ICommonInputsControls";
import { IData as IDoelgroep } from "../../../store/outreach/OutreachDoelgroepen";
import { useTranslation } from 'react-i18next';


// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

interface IDoelgroepOption extends IOption {
    doelgroep: IDoelgroep;
}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonMultiSelectControls<IDoelgroep>;
export const DoelgroepenSelect = (props: AllProps) => {

    const { t } = useTranslation('datatypes');
    

    const mapDoelgroepToOption = (doelgroep: IDoelgroep): IDoelgroepOption => ({value: doelgroep.code, label: doelgroep.naam, doelgroep: doelgroep})
    const mapOptionToDoelgroep = (option: IDoelgroepOption): IDoelgroep => option.doelgroep;
    
    const doelgroepen = props.options.map(mapDoelgroepToOption);
    const value = props.value?.map(mapDoelgroepToOption);


    const label = props.label || t('doelgroepenLabel') || "Doelgroepen";
    return <MultiSelect
        {...props}

        label={label}
        placeholder={t('doelgroepenPlaceholder') || "Selecteer doelgroepen..."}

        options={doelgroepen}
        value={value}

        onChange={(value, isValid) => props.onChange && props.onChange(value?.map(mapOptionToDoelgroep) || null, isValid)}
        onValidate={(value) => props.onValidate ? props.onValidate(value?.map(mapOptionToDoelgroep) || null) : [false, ""] }

    />
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));